import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import {
  ConfirmacaoComponent,
  ConfirmDialogModel,
} from "../dados-form/confirmacao/confirmacao.component";
import { DadosFormService } from "./doador.service";

@Component({
  selector: "app-doador",
  templateUrl: "./doador.component.html",
  styleUrls: ["./doador.component.css"],
})
export class DoadorComponent implements OnInit {
  @Input() doador: FormGroup;
  @Input() captacao: FormGroup;
  @Input() maiorDeIdade: boolean;
  @Output() cep = new EventEmitter();
  @Output() cpf = new EventEmitter();
  @Output() cepResponsavel1 = new EventEmitter();
  @Output() cepResponsavel2 = new EventEmitter();
  @Output() onIdadeChange = new EventEmitter<boolean>();
  @Input() finalizarCliente: boolean;
  @Input() desabilitarFormResp: boolean;
  @Input() contratoValido: boolean;
  @Input() desabilitarBotoes: boolean;
  @Input() codigoDoador: number;
  result: string = "";
  @Output() onFinalizarCliente = new EventEmitter<boolean>();

  horizontalPosition: MatSnackBarHorizontalPosition = "center";
  verticalPosition: MatSnackBarVerticalPosition = "top";

  constructor(
    private doadorService: DadosFormService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {}

  consultaCep() {
    this.cep.emit();
  }

  consultaCepResponsavel1() {
    this.cepResponsavel1.emit();
  }

  consultaCepResponsavel2() {
    this.cepResponsavel2.emit();
  }

  consultaCPF() {
    this.cpf.emit();
  }

  ngOnInit(): void {
    this.checkIdade();
    this.validateAllFormFields(this.doador);
    this.validateAllFormFields(this.captacao);
  }

  desabilitarInputCPF() {
    this.doador.get("cpf").disable();
    return;
  }

  // finalizarEdicaoCliente() {
  //   this.doadorService.sendClose("0");
  //   this.doadorService.sendClose("1");
  // }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }

  checkIdade() {
    let dataNascimento = this.doador.get("dataNascimento").value;
    if (!dataNascimento) {
      this.maiorDeIdade = true;
      return;
    }
    let dataN = dataNascimento.split("/");
    let dataA = dataN[2];
    let dataM = dataN[1];
    let dataD = dataN[0];
    let date = new Date();
    let dataNFormatada = `${dataM}/${dataD}/${dataA}`;

    let dataNascimentoFormatada = new Date(dataNFormatada);
    let idade = parseInt(
      this.calcularIdade(dataNascimentoFormatada, date) + ""
    );
    this.maiorDeIdade = idade < 18 ? false : true;
    this.onIdadeChange.emit(this.maiorDeIdade);
  }

  calcularIdade(nascimento, hoje) {
    var idade = hoje.getFullYear() - nascimento.getFullYear();
    if (
      new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) <
      new Date(hoje.getFullYear(), nascimento.getMonth(), nascimento.getDate())
    )
      idade--;
    return idade;
  }

  finalizarContrato() {
    const message = ``;

    const dialogData = new ConfirmDialogModel(
      "Deseja finalizar o cadastro do cliente? Após a finalização não será possível editar o mesmo.",
      message,
      "Finalizar"
    );

    const dialogRef = this.dialog.open(ConfirmacaoComponent, {
      maxWidth: "400px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      this.result = dialogResult;
      if (this.result == "true") {
        this.finalizarEdicaoCliente();
        this.desabilitarBotoes = true;
        return;
      }
    });
  }

  validateAllFormFields(formGroup: FormGroup) {
    //{1}
    Object.keys(formGroup.controls).forEach((field) => {
      //{2}
      const control = formGroup.get(field); //{3}
      if (control instanceof FormControl) {
        //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        //{5}
        this.validateAllFormFields(control); //{6}
      }
    });
  }

  finalizarEdicaoCliente() {
    this.doadorService
      .updateFlag(this.codigoDoador, "cliente", this.dataHoraAtual())
      .subscribe((res) => {
        this.openSnackBar("Cliente finalizado com sucesso!", "Fechar");
        this.doador.disable();
        this.desabilitarFormResps();
        this.finalizarCliente = true;
        this.desabilitarBotoes = true;
        this.onFinalizarCliente.emit(true);
      });
  }

  desabilitarFormResps() {
    this.captacao.get("cpfResponsavel1").disable(),
      this.captacao.get("rgResponsavel1").disable(),
      this.captacao.get("emailResponsavel1").disable(),
      this.captacao.get("telefoneCelularResponsavel1").disable(),
      this.captacao.get("cepResponsavel1").disable(),
      this.captacao.get("enderecoResponsavel1").disable(),
      this.captacao.get("bairroResponsavel1").disable(),
      this.captacao.get("cidadeResponsavel1").disable(),
      this.captacao.get("estadoResponsavel1").disable(),
      this.captacao.get("numEnderecoResponsavel1").disable(),
      this.captacao.get("estadoCivilResp1").disable(),
      this.captacao.get("nacionalidadeResp1").disable(),
      this.captacao.get("profissaoResp1").disable(),
      this.captacao.get("grauParentescoResp1").disable(),
      this.captacao.get("cpfResponsavel2").disable(),
      this.captacao.get("rgResponsavel2").disable(),
      this.captacao.get("emailResponsavel2").disable(),
      this.captacao.get("telefoneCelularResponsavel2").disable(),
      this.captacao.get("cepResponsavel2").disable(),
      this.captacao.get("enderecoResponsavel2").disable(),
      this.captacao.get("bairroResponsavel2").disable(),
      this.captacao.get("cidadeResponsavel2").disable(),
      this.captacao.get("estadoResponsavel2").disable(),
      this.captacao.get("numEnderecoResponsavel2").disable(),
      this.captacao.get("estadoCivilResp2").disable(),
      this.captacao.get("nacionalidadeResp2").disable(),
      this.captacao.get("profissaoResp2").disable(),
      this.captacao.get("grauParentescoResp2").disable(),
      this.captacao.get("nomeResponsavel1").disable(),
      this.captacao.get("nomeResponsavel2").disable(),
      this.captacao.get("dataNascimentoResponsavel1").disable(),
      this.captacao.get("dataNascimentoResponsavel2").disable(),
      this.captacao.get("complementoResponsavel1").disable(),
      this.captacao.get("complementoResponsavel2").disable(),
      this.captacao.get("telefoneResponsavel1").disable(),
      this.captacao.get("telefoneResponsavel2").disable();
  }

  dataHoraAtual(): string {
    let data = new Date();
    let dataLocal = data.toLocaleDateString();
    let horaLocal = data.toLocaleTimeString();

    let dataHoraAtual = dataLocal + " " + horaLocal;
    return dataHoraAtual;
  }
}
